// Standard-Lastprofile (stundenweise, normiert auf 1 kWh Tagesverbrauch)
// 24 Stundenwerte (0-23h), Anteil am Tagesverbrauch

export const standardLoadProfiles = {
  // Privat: Morgens kurzes Peak, abendbetonter Verbrauch
  residential: {
    label: "Privat - Wohngebäude",
    hourly: [0.02, 0.015, 0.01, 0.01, 0.01, 0.015, 0.03, 0.055, 0.05, 0.04, 0.035, 0.04, 0.05, 0.04, 0.035, 0.04, 0.05, 0.065, 0.08, 0.085, 0.07, 0.06, 0.045, 0.03],
  },
  // Gewerbe Einschicht: 07-17 Uhr Hauptlast
  business_single: {
    label: "Gewerbe - Einschicht",
    hourly: [0.01, 0.01, 0.01, 0.01, 0.01, 0.01, 0.02, 0.07, 0.09, 0.09, 0.08, 0.08, 0.07, 0.08, 0.08, 0.08, 0.07, 0.04, 0.02, 0.01, 0.01, 0.01, 0.01, 0.01],
  },
  // Gewerbe Zweischicht: 06-22 Uhr Hauptlast
  business_double: {
    label: "Gewerbe - Zweischicht",
    hourly: [0.015, 0.015, 0.015, 0.015, 0.015, 0.02, 0.055, 0.065, 0.065, 0.06, 0.055, 0.055, 0.05, 0.055, 0.06, 0.06, 0.055, 0.055, 0.05, 0.045, 0.04, 0.03, 0.02, 0.015],
  },
  // Gewerbe Dreischicht: Gleichmäßig verteilt, leicht tagbetont
  business_triple: {
    label: "Gewerbe - Dreischicht / 24h",
    hourly: [0.038, 0.036, 0.035, 0.035, 0.035, 0.036, 0.040, 0.045, 0.048, 0.048, 0.047, 0.046, 0.044, 0.045, 0.046, 0.046, 0.045, 0.044, 0.042, 0.041, 0.040, 0.039, 0.038, 0.037],
  },
};

// Standard-PV-Ertragsprofil (stundenweise, normiert auf 1 kWh Tagesertrag)
export const standardPvGenerationProfile = {
  label: "PV-Standardertrag (Zentraleuropa)",
  hourly: [0, 0, 0, 0, 0, 0.005, 0.02, 0.05, 0.08, 0.11, 0.13, 0.14, 0.14, 0.13, 0.11, 0.08, 0.05, 0.02, 0.005, 0, 0, 0, 0, 0],
};

// Calculate hourly overlap between load and PV generation
export function calculateDirectConsumptionShareTimeBased(loadProfileKey, annualConsumption, annualPvYield) {
  const loadProfile = standardLoadProfiles[loadProfileKey] || standardLoadProfiles.residential;
  const pvProfile = standardPvGenerationProfile;

  if (!annualPvYield || annualPvYield <= 0) return 0;

  const dailyConsumption = annualConsumption / 365;
  const dailyPvYield = annualPvYield / 365;

  let totalDirectConsumption = 0;
  for (let h = 0; h < 24; h++) {
    const loadKwh = dailyConsumption * loadProfile.hourly[h];
    const pvKwh = dailyPvYield * pvProfile.hourly[h];
    totalDirectConsumption += Math.min(loadKwh, pvKwh);
  }

  const directShare = totalDirectConsumption / dailyPvYield;
  return Math.max(0.05, Math.min(0.95, directShare));
}

// Get the appropriate load profile key
export function getLoadProfileKey(customerType, shiftType) {
  if (customerType === 'private') return 'residential';
  switch (shiftType) {
    case 'double': return 'business_double';
    case 'triple': return 'business_triple';
    default: return 'business_single';
  }
}

export const businessLoadProfiles = {
  office:       { activeHoursPerDay: 10, baseLoadShare: 0.20, peakFactor: 1.6, weekendShare: 0.10, label: "Büro" },
  workshop:     { activeHoursPerDay: 10, baseLoadShare: 0.25, peakFactor: 1.9, weekendShare: 0.10, label: "Werkstatt" },
  production:   { activeHoursPerDay: 16, baseLoadShare: 0.40, peakFactor: 1.8, weekendShare: 0.35, label: "Produktion" },
  retail:       { activeHoursPerDay: 10, baseLoadShare: 0.20, peakFactor: 1.7, weekendShare: 0.20, label: "Handel" },
  agriculture:  { activeHoursPerDay: 12, baseLoadShare: 0.35, peakFactor: 1.8, weekendShare: 0.40, label: "Landwirtschaft" },
  hospitality:  { activeHoursPerDay: 16, baseLoadShare: 0.40, peakFactor: 1.6, weekendShare: 0.50, label: "Gastronomie" },
  other:        { activeHoursPerDay: 10, baseLoadShare: 0.25, peakFactor: 1.7, weekendShare: 0.20, label: "Sonstiges" },
};

export const businessConsumptionDefaults = {
  office: { typicalAnnualKwh: 15000 }, workshop: { typicalAnnualKwh: 30000 },
  production: { typicalAnnualKwh: 80000 }, retail: { typicalAnnualKwh: 25000 },
  agriculture: { typicalAnnualKwh: 40000 }, hospitality: { typicalAnnualKwh: 35000 },
  other: { typicalAnnualKwh: 25000 },
};

export const shiftTypes = [
  { value: "single", label: "Einschicht (z. B. 07:00–17:00)" },
  { value: "double", label: "Zweischicht" },
  { value: "triple", label: "Dreischicht / Dauerbetrieb" },
];

export const industryOptions = [
  { value: "office", label: "Büro" }, { value: "workshop", label: "Werkstatt" },
  { value: "production", label: "Produktion" }, { value: "retail", label: "Handel" },
  { value: "agriculture", label: "Landwirtschaft" }, { value: "hospitality", label: "Gastronomie" },
  { value: "other", label: "Sonstiges" },
];
